module.exports = __webpack_public_path__ + "img/section5.b46e6f12.png";